@if ((appFacadeService.getTransactionLoaded() | async) && (appFacadeService.isPaymentOpen() | async)) { @if (appFacadeService.getPaymentAppInput() | async; as paymentAppInput) {
<div>
    <por-payment-app-credit-card
        id="paymentAppCreditCard"
        *axLazyElement="porPayURL"
        [paymentAppInput]="paymentAppInput"
        (paymentAppOutput)="appFacadeService.onPaymentFinished($any($event))"></por-payment-app-credit-card>
</div>
} } @else { @if ((appFacadeService.getLoader() | async) !== true) {
<!--
Only when the app-wide loader is NOT already up. Both are on screen during the same window -
por-app-loader for the store's loading state, this one because the POR-Pay element is not open
yet - which read as two stacked spinners (and, in the embedded payment component, sandwiched the
tokenize-only notice between them).
-->
<por-busy-indicator [message]="'Loading' | translate" />
} } @if (appFacadeService.isDialogEnabled() | async) {
<por-app-confirm-dialog [message]="(appFacadeService.getPaymentError() | async) ?? ''" (confirmed)="appFacadeService.closePaymentDialog()" [externalClass]="'none'"></por-app-confirm-dialog>
}
